module.exports = __webpack_public_path__ + "img/Restaurant9.c57c25a9.png";